import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { captureException } from './utils/capture-exception';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 2,
    },
  },
  mutationCache: new MutationCache({
    onError: (err, variables) => {
      import('@sentry/react').then((Sentry) => {
        Sentry.addBreadcrumb({
          category: 'mutation',
          data: { variables },
        });
      });
      captureException(err);
    },
  }),
  queryCache: new QueryCache({
    onError: (err, query) => {
      import('@sentry/react').then((Sentry) => {
        Sentry.addBreadcrumb({
          category: 'query',
          message: query.queryHash,
        });
      });
      captureException(err);
    },
  }),
});
